import {
  IconName,
  KebabMenu,
  KebabMenuIconPosition
} from '@focaldata/cin-ui-components'
import { QuestionnaireHeaderChip } from '../HeaderLabels/QuestionnaireHeaderChip'

interface Props {
  onRemoveQuestionOrderRandomised: () => void
}

const RandomisationActionMenuControl = ({
  onRemoveQuestionOrderRandomised
}: Props) => {
  return (
    <KebabMenu
      kebabMenuOptions={[
        {
          id: 0,
          textItem: 'Remove question order randomisation',
          onClickItem: onRemoveQuestionOrderRandomised,
          iconName: IconName.DeleteOutline
        }
      ]}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left'
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left'
      }}
      iconPosition={KebabMenuIconPosition.Left}
      menuButton={
        <QuestionnaireHeaderChip iconName={IconName.Shuffle}>
          Question order randomised
        </QuestionnaireHeaderChip>
      }
    />
  )
}

export default RandomisationActionMenuControl
